import { LocalParticipant, RemoteParticipant } from 'livekit-client'

import { ESpecificUsernames } from '@/src/constants/constants'

export const checkIsRealParticipant = (participant: RemoteParticipant | LocalParticipant) => {
  if (participant?.permissions?.agent) {
    return false
  }

  if (participant?.permissions?.recorder) {
    return false
  }

  // Это условие нужно для того, чтобы не включать участников, которые сидят в комнате ожидания
  if (!participant?.permissions?.canSubscribe && !participant?.permissions?.canPublish) {
    return false
  }

  return true
}

export const getVisibleParticipants = (remoteParticipants: Map<string, RemoteParticipant>) =>
  Array.from(remoteParticipants, ([name, value]) => value).filter((remoteParticipant) =>
    checkIsRealParticipant(remoteParticipant),
  )

export const getParticipantsInWaitingRoom = (remoteParticipants: Map<string, RemoteParticipant>) =>
  Array.from(remoteParticipants, ([name, value]) => value).filter(
    (remoteParticipant) =>
      !remoteParticipant?.permissions?.canPublish &&
      !remoteParticipant?.permissions?.canSubscribe &&
      remoteParticipant?.name !== ESpecificUsernames.Recorder &&
      remoteParticipant?.name !== ESpecificUsernames.Guest,
  )
